import api, { apiWrapper } from '../api/axios';

export const getBranches = async (
    {
    status = 'all', search=null,
    page = 1, pageSize = 20, paginate = true
  }
) => {
  let params = {
    status,
    page,
    page_size: pageSize,
    paginate
  };
  if (search != null) {
    params = { ...params, search };
  }
  return apiWrapper(() => api.get(`/branch/`, { params }));
};

export const createBranch = async (data) => {
  return apiWrapper(() => api.post("/branch/", data));
};

export const updateBranch = async (id, data) => {
  return apiWrapper(() => api.put(`/branch/${id}/`, data));
};

export const updateBranchPartial = async (id, data) => {
  return apiWrapper(() => api.patch(`/branch/${id}/`, data));
};

export const toggleBranchStatus = async (id, isActive) => {
  return apiWrapper(() => api.patch(`/branch/${id}/${isActive ? 'activate' : 'deactivate'}/`));
};
